import React from 'react';
import { Col, Form, FormGroup, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button } from 'reactstrap';

export const FormMethod = (props) => {
    const {
        toggle, loading, handleInputChange, validaciones, methodAction, name, code, button
    } = props;

    const {
        name_valid,
        code_valid,
    } = validaciones;

    return (
        <Form className="" role="form" >
            <Row>
                <Col md="6">
                    <FormGroup>
                        <Label className="col-form-label">Nombre <span style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className="form-control form-control-sm input-air-primary"
                            type="text"
                            //  placeholder="Nombre del método"
                            name="name"
                            onChange={handleInputChange}
                            value={name}
                            autoComplete="off"
                            invalid={name_valid}
                        />
                        <FormFeedback>Minimo 3 caracteres</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup>
                        <Label className="col-form-label">Clave <span style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className="form-control form-control-sm input-air-primary"
                            type="text"
                            //placeholder="Clave"
                            name="code"
                            onChange={handleInputChange}
                            value={code}
                            autoComplete="off"
                            invalid={code_valid}
                        />
                        <FormFeedback>Minimo 2 caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>

        </Form>
    )
};
